import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import _ from "lodash";

const CustomTextField = ({
  control,
  name,
  label,
  rules,
  required,
  helperText,
  ...props
}) => {
  const controllerRules = rules || { required };
  return (
    <Controller
      control={control}
      name={name}
      rules={controllerRules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          sx={{ backgroundColor: "#ffff", borderRadius: 3 }}
          error={!_.isEmpty(error)}
          variant="outlined"
          {...field}
          {...props}
          helperText={!_.isEmpty(error) ? error.message : helperText}
          label={label && `${label}${controllerRules.required ? "*" : ""}`}
        />
      )}
    />
  );
};

export default CustomTextField;
